import React from 'react';
import Backdrop from './Backdrop';
import ButtonDisconnect from './buttons/ButtonDisconnect';
import { Tooltip } from 'react-tooltip';
import { locales } from '../translations/locales';
import { BsFillSunFill, BsMoonStarsFill } from 'react-icons/bs';

const RightMenu = (props) => {
    const { session, setMenuOpen, setLocale, locale, setTheme, theme } = props;

    return (
        <>
            <Backdrop setMenuOpen={setMenuOpen} />
            <div className={`rightMenu rm-${theme === 'DARK' ? 'dark' : 'light'}`}>
                <div className={`rightMenu-top rmt-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <div
                        className={`closeButton ${theme === 'DARK' ? 'dark' : 'light'}`}
                        onClick={() => setMenuOpen(false)}
                    >
                        &times;
                    </div>
                    <h6>{locales[locale].account}</h6>
                    <h5 className={`h5-${theme === 'DARK' ? 'dark' : 'light'}`}>{session.userName}</h5>
                </div>
                <div className='rightMenu-nav'>
                    <div className="slide-r-nav mt-2 p-2">
                        <a href="https://alertes-speciales.fr/comptes/tableau-de-bord" className="link-slide-r">
                            {locales[locale].rightMenu.dashboard}
                        </a>
                    </div>
                    <div className="slide-r-nav mt-2 p-2">
                        <a href="https://alertes-speciales.fr/comptes" className="link-slide-r">
                            {locales[locale].rightMenu.manage}
                        </a>
                    </div>
                    <div className="slide-r-nav mt-2 p-2">
                        <a href="https://alertes-speciales.fr/comptes/vos-achats" className="link-slide-r">
                            {locales[locale].rightMenu.buy}
                        </a>
                    </div>
                    <div className="slide-r-nav mt-2 p-2">
                        <a href="https://alertes-speciales.fr/comptes/acheter-des-extras" className="link-slide-r">
                            {locales[locale].rightMenu.shop}
                        </a>
                    </div>
                    <div className="slide-r-nav mt-2 p-2">
                        <a href="https://alertes-speciales.fr/comptes/succes" className="link-slide-r">
                            {locales[locale].rightMenu.success}
                        </a>
                    </div>

                    <div className="slide-r-nav-flag mt-2 p-2">
                        <img
                            src='./images/locale/fr.webp'
                            data-tip data-tooltip-id='flag'
                            onClick={() => setLocale('FR')}
                            className='flag m-1 p-1 float-left'
                            alt='français'
                        />
                        <img
                            src='./images/locale/en.webp'
                            data-tip data-tooltip-id='flag'
                            onClick={() => setLocale('EN')}
                            className='flag m-1 p-1 float-right'
                            alt='anglais'
                        />
                        <img
                            src='./images/locale/de.webp'
                            data-tip data-tooltip-id='flag'
                            onClick={() => setLocale('DE')}
                            className='flag m-1 p-1 float-right'
                            alt='allemand'
                        />
                        <Tooltip id='flag' place='top' effect='solid' className='text-center'>
                            {locales[locale].chooseLangage}
                        </Tooltip>
                    </div>

                    <div className="slide-r-nav-flag mt-5 p-2 text-center">
                        {
                            (
                                theme === 'DARK' ?
                                    <BsFillSunFill className='cursor-pointer' data-tip data-tooltip-id='theme' onClick={() => setTheme('LIGHT')} /> :
                                    <BsMoonStarsFill className='cursor-pointer' data-tip data-tooltip-id='theme' onClick={() => setTheme('DARK')} />
                            )
                        }
                        <Tooltip id='theme' place='top' effect='solid' className='text-center'>
                            {theme === 'DARK' ? locales[locale].changeThemeLight : locales[locale].changeThemeDark}
                        </Tooltip>
                    </div>

                    <ButtonDisconnect session={session} locale={locale} theme={theme} />
                </div>
            </div>
        </>
    );
};

export default RightMenu;
